import React, { useState } from 'react'
import Header from '../components/header'
import Footer from '../components/footer'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import emailjs from 'emailjs-com';

export default function Saas() {

    let [userInfo, setUserInfo] = useState({
        name: "",
        email: "",
        phone: "",
        message: ""
    });

    let [check, setCheck] = useState(false)


    let handleBlogForm = (event) => {
        setCheck(true);
        event.preventDefault();
        if (
            !userInfo.name?.trim() ||
            !userInfo.email?.trim() ||
            !userInfo.phone?.trim() ||
            !userInfo.message?.trim()
        ) {
            alert("Required fields must not be empty");
            setCheck(false);
            return; // stop further execution if needed
        }


        emailjs
            .send(
                "service_fh21hk1",
                "template_egilf03",
                {
                    name: userInfo.name,
                    phone: userInfo.phone,
                    email: userInfo.email,
                    message: userInfo.message,
                },
                "F__APn9baLCfQyoXa"
            )
            .then(() => {
                alert("Message sent successfully!");
            })
            .catch(() => {
                alert("Failed to send message. Please try again.");
            })
            .finally(() => {
                setCheck(false);
            });





    }

    return (
        <div className='sas'>
            <Helmet>
                <title>Write for Us – SaaS | Submit Guest Posts on Software as a Service</title>
                <meta
                    name="description"
                    content="Contribute to Tooliso's SaaS blog! Submit high-quality guest posts on software as a service, trends, tools, and tips. Share your expertise with a tech-savvy audience."
                />
                <link rel="canonical" href="https://tooliso.com/write-for-us-saas" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Write for Us – SaaS | Guest Blogging on Software as a Service" />
                <meta property="og:description" content="Looking to write about SaaS? Submit your guest post to Tooliso and get featured. Ideal for marketers, developers, and SaaS founders." />
                <meta property="og:url" content="https://tooliso.com/write-for-us-saas" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Tooliso" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Write for Us – SaaS | Submit Guest Posts" />
                <meta name="twitter:description" content="Contribute to Tooliso's SaaS blog and share your insights with our growing audience. Guest blogging opportunities available now!" />
            </Helmet>

            <Header />
            <div className="saaspage">
                <h1>Write for Us and Join Our Innovative SaaS Blogging Community!</h1>
                <p>Welcome to tooliso.com, your go-to resource for all things
                    Software as a Service (SaaS). We encourage content creators,
                    SaaS professionals, and tech bloggers to share their insights
                    and expertise by submitting guest posts. Our aim is to offer
                    in-depth knowledge about the dynamic SaaS landscape, including
                    areas like cloud computing, subscription models, and SaaS MVP
                    development. If you're enthusiastic about SaaS and eager to
                    connect with a larger audience, contribute a guest post and
                    become part of our expanding community.</p>
                <a href="#submit_your_guest_post_now">Submit Your Guest Post Now</a>
            </div>
            <div className="saassections">
                <section>
                    <h2>Why Contribute to Our SaaS Platform?</h2>
                    <ul>
                        <li style={{ margin: "10px" }}><strong>Boost Your Online Presence : </strong> Connect with a diverse, tech-savvy audience.</li>
                        <li style={{ margin: "10px" }}><strong>Establish Thought Leadership : </strong> Share your SaaS solutions and insights.</li>
                        <li style={{ margin: "10px" }}><strong>Interactive Community Engagement : </strong> Join discussions with fellow SaaS experts and enthusiasts.</li>
                        <li style={{ margin: "10px" }}><strong>Professional Exposure : </strong> Elevate your professional profile in the SaaS industry.</li>
                        <li style={{ margin: "10px" }}><strong>Networking Opportunities : </strong> Connect with SaaS entrepreneurs and developers.</li>
                        <li style={{ margin: "10px" }}><strong>Constructive Feedback : </strong> Benefit from editorial insights to hone your writing skills.</li>
                    </ul>
                </section>

            </div>
            <div className="saaspage">
                <h1>Our Content Expectations</h1>
                <p>
                    At Tooliso, our goal is to publish content that genuinely connects with our audience and reflects a strong understanding of the SaaS landscape.
                    We want submissions that inform and captivate readers, providing them with valuable insights into the ever-changing world of Software as a Service.
                    Your articles should combine <span style={{ fontWeight: "600" }}>expert knowledge with practical examples</span>, showcasing the newest SaaS <span style={{ fontWeight: "600" }}>innovations and technological progress</span>. We value
                    original, persuasive, and <span style={{ fontWeight: "600" }}>informative pieces</span> that offer our readers a complete grasp of SaaS concepts and emerging trends.
                </p>
            </div>
            <section>
                <h2>Submission Guidelines for SaaS Guest Posts</h2>
                <ol>
                    <li style={{ margin: "10px" }}><strong>Unique Insights:</strong> We prioritize exclusive, insightful articles that add value.</li>
                    <li style={{ margin: "10px" }}><strong>SaaS-focused Topics:</strong> Delve into SaaS strategies, software development trends, cloud computing, SaaS business models, or user experience design.</li>
                    <li style={{ margin: "10px" }}><strong>High-Quality Standards:</strong> Engaging, well-researched, and informative content is our benchmark.</li>
                    <li style={{ margin: "10px" }}><strong>Detailed Analysis:</strong> We welcome deep dives into SaaS best practices and innovations.</li>
                    <li style={{ margin: "10px" }}><strong>Required Length:</strong> Aim for comprehensive human-written articles of over 800 words. You can use this <Link to={'/Counter'}>word counter</Link> tool to check the word count.</li>
                    <li style={{ margin: "10px" }}><strong>No Promotional Material:</strong> We maintain an unbiased, informative tone.</li>
                </ol>
            </section>

            <section>
                <h2>Explore the Topics We Love: Accepted Categories for Guest Blog Post Submissions</h2>
                <ul>
                    <li style={{ margin: "10px" }}>WordPress Themes & Plugins</li>
                    <li style={{ margin: "10px" }}>Tips about writing blogs</li>
                    <li style={{ margin: "10px" }}>Web design and web development</li>
                    <li style={{ margin: "10px" }}>Search Engine Optimization (SEO)</li>
                    <li style={{ margin: "10px" }}>Affiliate blogging / Make money online with blogging</li>
                    <li style={{ margin: "10px" }}>Social Media Marketing</li>
                    <li style={{ margin: "10px" }}>Mobile App Development</li>
                    <li style={{ margin: "10px" }}>E-commerce Business</li>
                    <li style={{ margin: "10px" }}>Business</li>
                    <li style={{ margin: "10px" }}>Social Media Marketing Techniques</li>
                    <li style={{ margin: "10px" }}>Virtual Reality in gaming, business, and marketing</li>
                    <li style={{ margin: "10px" }}>Cybersecurity threats and their solutions</li>
                    <li style={{ margin: "10px" }}>Cloud Computing solutions for both small and enterprise businesses</li>
                    <li style={{ margin: "10px" }}>Usage of Augmented Reality</li>
                    <li style={{ margin: "10px" }}>How-to tutorials about WordPress, blogging, writing, SMM, programming, and online business</li>
                    <li style={{ margin: "10px" }}>Case studies about Internet marketing, freelancing, and affiliate marketing</li>
                    <li style={{ margin: "10px" }}>Digital Marketing Tips & Tricks</li>
                    <li style={{ margin: "10px" }}>Online Business Ideas</li>
                    <li style={{ margin: "10px" }}>Software as a Service (SaaS)</li>
                    <li style={{ margin: "10px" }}>Artificial Intelligence & AI Writing Tools</li>
                    <li style={{ margin: "10px" }}>Content Writing</li>
                    <li style={{ margin: "10px" }}>User Experience (UX) and User Interface (UI) Design</li>
                </ul>
            </section>

            <div id="submit_your_guest_post_now">
                <h1>Submit Your Guest Blog Post</h1>
                <p>this form will automatically send to <a href="mailto:tooliso100@gmail.com">tooliso100@gmail.com</a></p>
                <form onSubmit={handleBlogForm}>
                    <div className="inputSaas">
                        <p>Your Name (required)</p>
                        <input type="text" value={userInfo.name} onChange={(e) => setUserInfo({ ...userInfo, name: e.target.value })} />
                    </div>
                    <div className="inputSaas">
                        <p>Your Phone no. (required)</p>
                        <input type="text" value={userInfo.phone} onChange={(e) => setUserInfo({ ...userInfo, phone: e.target.value })} />
                    </div>
                    <div className="inputSaas">
                        <p>Your Email (required)</p>
                        <input type="text" value={userInfo.email} onChange={(e) => setUserInfo({ ...userInfo, email: e.target.value })} />
                    </div>
                    <div className="inputSaas">
                        <p>Your Message (required)</p>
                        <textarea value={userInfo.message} onChange={(e) => setUserInfo({ ...userInfo, message: e.target.value })}></textarea>
                    </div>


                    {
                        check ?
                            <button className='saasbtn' style={{ cursor: "not-allowed" }}><div className='spinner'></div></button>
                            :
                           <>
                            <button className='saasbtn'>Submit your guest post</button>
                            <p>we will back to you soon</p>
                           </>
                    }

                </form>
            </div>

            <Footer />
        </div>
    )
}
